import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { PermissionResponse } from "@/types";

async function fetchPermissions(): Promise<PermissionResponse> {
  const response = await httpRequest.get<PermissionResponse>(`/permissions`);
  return response.data;
}

export function useFetchPermissionsQuery() {
  const rulesResponseQuery = useQuery({
    queryKey: ["permissions"],
    queryFn: () => fetchPermissions(),
    keepPreviousData: true,
  });

  return {
    ...rulesResponseQuery,
    data: rulesResponseQuery?.data,
  };
}
